import { Component } from '@angular/core';

/**
 * Skeleton component for order card
 * @export
 * @class AtmSkeletonOrderCardComponent
 */
@Component({
  selector: 'atm-skeleton-order-card',
  templateUrl: './atm-skeleton-order-card.component.html',
  styleUrls: ['./atm-skeleton-order-card.component.scss']
})
export class AtmSkeletonOrderCardComponent {

}
